const TEXT = {
    Team_CONTENT_TEXT_1:"团队",
    Team_CONTENT_TEXT_2:"查看资料",
    Team_CONTENT_TEXT_3:"团队人数",
    Team_CONTENT_TEXT_4:"新增人数",
    Team_CONTENT_TEXT_5:"当月业绩",
    Team_CONTENT_TEXT_6:"团队利润",
    Team_CONTENT_TEXT_7:"产品出货量",
    Team_CONTENT_TEXT_8:"团队库存",
    Team_CONTENT_TEXT_9:"代理层级",
    Team_CONTENT_TEXT_10:"总代",
    Team_CONTENT_TEXT_11:"一级代理",
    Team_CONTENT_TEXT_12:"二级代理",
    Team_CONTENT_TEXT_13:"团队资料",
    Team_CONTENT_TEXT_14:"团队头像",
    Team_CONTENT_TEXT_15:"团队名称",
    Team_CONTENT_TEXT_16:"团队队长",
    Team_CONTENT_TEXT_17:"团队介绍",
    Team_CONTENT_TEXT_18:"保存",
    Team_CONTENT_TEXT_19:"团队人数",
    Team_CONTENT_TEXT_20:"新增人数",
    Team_CONTENT_TEXT_21:"团队业绩",
    Team_CONTENT_TEXT_22:"直推人数",
    Team_CONTENT_TEXT_23:"编辑",
};
export {
	TEXT
}


// WEBPACK FOOTER //
// ./src/config/page/cn/team/index.js